import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactsService {
  private supportEmail: string = 'info@finshop.by';

  constructor() {}

  public getSupportEmail(): string {
    return this.supportEmail;
  }
}
